import { render, staticRenderFns } from "./UserOptionsPage.vue?vue&type=template&id=089fbf1b&scoped=true&"
import script from "./UserOptionsPage.vue?vue&type=script&lang=js&"
export * from "./UserOptionsPage.vue?vue&type=script&lang=js&"
import style0 from "./UserOptionsPage.vue?vue&type=style&index=0&id=089fbf1b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "089fbf1b",
  null
  
)

export default component.exports